import axios from "axios";
import { Assessor } from "./Domain";
import useGlobalPromise from "./useGlobalPromise";

export default () =>
	useGlobalPromise("ald_decra_assessors", async () =>
		(await axios.get<Assessor[]>(`/api/assessors`)).data
	);
